export enum Features {
  COMMON = '@@common',
  RADAR = '@@radar',
  RECORD = '@@record',
}
